export enum QuestionPrefix {
  Question = 'Q',
  HiddenQuestion = 'H',
  Source = 'SC',
  SourceVariable = 'SV',
  SystemSourceVariable = 'SSV'
}
